// extracted by mini-css-extract-plugin
module.exports = {"builder":"_02712f2b3b--builder--UaU_Q","info":"_02712f2b3b--info--lMz9Z","statistic":"_02712f2b3b--statistic--xnTrY"};